import template from './kdatepicker.html';
import controller from './kdatepicker.controller';
import 'flatpickr/dist/flatpickr.css';

import './kdatepicker.scss';

export default {
	template,
	controller,
	transclude: true,
	bindings:   {
		id:         '@?',
		ngDisabled: '<?',
		ngModel:    '<',
		ngRequired: '<?',
		options:    '<?',
	},
	require:    {
		ngModelCtrl: 'ngModel',
		form:        '^^?',
	},
};
